import httpClient from "./_httpClient";

const END_POINT = "/invoices";

const uploadExcel = (scopeId, excelFile, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", excelFile);
  if (scopeId) {
      formData.append("scopeId", scopeId);
  }
  return httpClient.post(
    END_POINT + "/import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
};
const getInvoice = (invoiceId) => httpClient.get(END_POINT + "/" +invoiceId);
const addInvoice = (invoiceData) => httpClient.post(END_POINT, invoiceData);
const editInvoice = (id,invoiceData) => httpClient.put(END_POINT + '/' + id, invoiceData);
const deleteInvoice = (id) => httpClient.delete(END_POINT + '/' + id);

const exportInvoices = (config) => httpClient.get(END_POINT + "/export", config);
const exportInvoicesByScope = (scopeId,config) => httpClient.get(END_POINT + "/export/" + scopeId, config);
const getPreImportRapport = (attachment, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", attachment);
  return httpClient.post(
    END_POINT + "/rapport",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
}

export {
  uploadExcel,
  getInvoice,
  addInvoice,
  editInvoice,
  deleteInvoice,
  exportInvoices,
  exportInvoicesByScope,
  getPreImportRapport
}
